// Mobile megamenu.
document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('site-header');
    const megamenu = document.querySelector('[data-megamenu]');
    if (!header || !megamenu) return;

    let timeout;

    const closeOnClickOutside = (event) => {
        if (
            !header.contains(event.target) &&
            megamenu.classList.contains('show')
        ) {
            megamenu.classList.remove('in');
            timeout = setTimeout(() => {
                megamenu.classList.remove('show');
            }, 300);
            document.removeEventListener('click', closeOnClickOutside);
        }
    };

    document.querySelectorAll('[data-toggle-megamenu]').forEach((element) =>
        element.addEventListener('click', async (event) => {
            event.preventDefault();
            const isOpen = megamenu.classList.contains('show');
            timeout && clearTimeout(timeout);

            if (isOpen) {
                megamenu.classList.remove('in');
                timeout = setTimeout(() => {
                    megamenu.classList.remove('show');
                }, 300);
            } else {
                megamenu.classList.add('show');
                await nextFrame();
                megamenu.classList.add('in');
                // Close megamenu when clicked outside
                document.addEventListener('click', closeOnClickOutside);
            }

            await afterTransition(megamenu);

            element.setAttribute(
                'aria-expanded',
                megamenu.classList.contains('show')
            );
        })
    );
});

// Menu dropdowns.
document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('site-header');
    if (!header) return;

    document.querySelectorAll('[data-header-dropdown]').forEach((element) => {
        const toggle = element.querySelector('[data-header-dropdown-toggle]');

        const closeOnClickOutside = (event) => {
            if (
                !element.contains(event.target) &&
                element.classList.contains('show')
            ) {
                element.classList.remove('show');
                document.removeEventListener('click', closeOnClickOutside);
            }
        };

        toggle.addEventListener('click', () => {
            const isOpen = element.classList.contains('show');
            element.classList.toggle('show', !isOpen);
            // Close dropdown when clicked outside
            document.addEventListener('click', closeOnClickOutside);
            element.setAttribute('aria-expanded', !isOpen);
        });
    });
});

function nextFrame() {
    return new Promise((resolve) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(resolve);
        });
    });
}

function afterTransition(element) {
    return new Promise((resolve) => {
        const duration =
            Number(
                getComputedStyle(element).transitionDuration.replace('s', '')
            ) * 1000;

        setTimeout(() => {
            resolve();
        }, duration);
    });
}
